import React, { createContext, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { ENV } from "../Infrastructure/EnvironmentConfig";
import "./reportviewer.css";

import ReportStore from "./ReportStore";
import { Drawer, notification } from "antd";
import { observer } from "mobx-react-lite";
import { FileText } from "react-feather";
import { getPickerDate } from "../Utility/modules/datePicker";

const reportStoreCtx = createContext(ReportStore);

// Telerik serializes parameters to JSON, so Moment/Dayjs values must be plain dates.
const normalizeReportParameters = (parameters) => {
  if (!parameters || typeof parameters !== "object") {
    return {};
  }

  return Object.entries(parameters).reduce((normalized, [key, value]) => {
    const dateValue = getPickerDate(value);
    normalized[key] = dateValue ? dateValue.toISOString() : value;
    return normalized;
  }, {});
};

export const ReportViewer = observer(() => {
  const reportStore = useContext(reportStoreCtx);

  // Telerik measures its container on init, so wait for the drawer animation to finish.
  const handleAfterOpenChange = (open) => {
    if (!open) {
      return;
    }

    try {
      reportLoad();
      window.dispatchEvent(new Event("resize"));
    } catch (error) {
      notification.error({
        key: "error",
        message: "SPARS Feedback",
        description: `Something went wrong why loading  the report engine dependencies, ${error.message} .Ensure your are connected to the network or internet or close the browser and login again`,
      });
    }
  };

  const reportLoad = () => {
    window.jQuery("#reportViewer1").telerik_ReportViewer({
      serviceUrl: `${ENV.API_ROOT}/reports`,
      templateUrl: "/assets/templates/telerikReportViewerTemplate-20.2.26.812.html",
      reportSource: {
        report: reportStore.reportName,
        parameters: normalizeReportParameters(reportStore.reportParameters),
      },

      scale: 1.0,
      viewMode: "INTERACTIVE",
      printMode: "SPECIFIC",
      sendEmail: { enabled: true },
      scaleMode: "SPECIFIC",
      enableAccessibility: false,
      renderingBegin: "",
      renderingEnd: "",
      printBegin: "",
      printEnd: "",
      exportBegin: "",
      exportEnd: "",
      updateUi: "",
      error: (e, args) => {
        const reportSource = e.currentTarget?.reportSource?.() || {};
        const { report } = reportSource;
        const messageBar = window.jQuery(
          ".trv-pages-area .trv-error-pane .trv-error-message"
        );
        switch (report) {
          case "QikReach.Reporting.Naoc.Naoc100FlashProduction,QikReach.Reporting":
            messageBar.html(
              "select NAOC asset production start date and end  date Range"
            );
            break;
          case "QikReach.Reporting.Naoc.NaocOandoEquityFlashReport,QikReach.Reporting":
            messageBar.html(
              "select NAOC asset production start date and end  date Range"
            );
            break;
          case "QikReach.Reporting.Naoc.OERReport,QikReach.Reporting":
            messageBar.html(
              "select OER Provisional NAOC JV Daily Production report date"
            );
            break;
          case "QikReach.Reporting.Naoc.Fiscalization,QikReach.Reporting":
            messageBar.html("select asset fiscalization year(s)");
            break;
          case "QikReach.Reporting.Naoc.EvacuationTarget,QikReach.Reporting":
            messageBar.html("select asset fiscalization year(s)");
            break;

          default:
            break;
        }
      },
      pageReady: "",
      ready: "",
      interactiveActionExecuting: "",
      interactiveActionEnter: "",
      interactiveActionLeave: "",
      viewerToolTipOpening: "",
      parameterEditors: [],
    });
  };

  return (
    <Drawer
      destroyOnClose={true}
      open={reportStore.showReportDialog}
      afterOpenChange={handleAfterOpenChange}
      onClose={() => {
        reportStore.showReportDialog = false;
      }}
      width="90%"
      bodyStyle={{ padding: "12px", overflow: "hidden" }}
      title={
        <div style={{ fontSize: "15px" }}>
          <FileText style={{ color: "gray" }} />{" "}
          <span>{reportStore.headerText}</span>
          {" Report"}
        </div>
      }
      placement="right"
    >
      <div id="reportViewer1">
        <div
          style={{
            display: "flex",
            height: "50vh",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Spinner
            label="Loading report services,please wait..."
            ariaLive="assertive"
            labelPosition="right"
            size={SpinnerSize.large}
          />
        </div>
      </div>
    </Drawer>
  );
});
